<template>
  <div class="story-border-settings">
    <div>
      <div class="toggle-box-title">
        <p v-if="header">
          {{ header }}
        </p>
        <slot> </slot>
      </div>
      <div class="buttons">
        <label :class="{ selected: selected === 'instagram' }">
          <input
            v-model="selected"
            type="radio"
            name="storyBorder"
            value="instagram"
          />
          {{ $t("create.step3.buttonSelector.instagram") }}
        </label>

        <label
          :class="{ selected: selected === 'custom' }"
          @click.prevent="onCustomClick"
        >
          <input
            type="radio"
            name="storyBorder"
            value="custom"
            :checked="selected === 'custom'"
          />
          {{ $t("create.step3.buttonSelector.custom") }}
          <span
            class="custom-dot"
            :style="{ backgroundColor: customColor }"
          ></span>
        </label>

        <label :class="{ selected: selected === 'none' }">
          <input
            v-model="selected"
            type="radio"
            name="storyBorder"
            value="none"
          />
          {{ $t("create.step3.buttonSelector.noBorder") }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StoryBorderColorSettings",
  props: {
    valueColor: { type: String, default: "#000000" },
    valueHasBorder: { type: Boolean, default: true },
    header: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selected: null,
      customColor: this.valueColor,
    };
  },
  watch: {
    valueHasBorder: {
      immediate: true,
      handler(has) {
        if (!has) this.selected = "none";
        else if (this.valueColor.toLowerCase() === "instagram")
          this.selected = "instagram";
        else if (this.valueColor) this.selected = "custom";
      },
    },
    valueColor(newColor) {
      this.customColor = newColor;
    },
    selected(newVal, oldVal) {
      if (newVal === "instagram") {
        this.$emit("update:borderColor", "instagram");
        this.$emit("update:hasBorder", true);
      } else if (newVal === "none") {
        this.$emit("update:hasBorder", false);
        this.$emit("update:borderColor", "#ffffff");
      } else if (newVal === "custom") {
        this.$emit("update:hasBorder", true);
        if (oldVal === "instagram" || oldVal === "none") {
          this.$emit("update:borderColor", "#000000");
        }
        this.openPicker();
      }
    },
  },
  methods: {
    openPicker() {
      this.$emit("open-picker", "borderColor");
    },
    onCustomClick() {
      if (this.selected === "custom") {
        this.openPicker();
      } else {
        this.selected = "custom";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.story-border-settings {
  @include font-small;
  @include base-font;
  text-align: left;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  &:hover {
    background-color: $settings-hover;
  }
}

.toggle-box-title {
  margin-bottom: 12px;
}
.buttons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
  border-radius: 3px;

  label {
    background-color: transparent;
    font-family: "Montserrat", sans-serif;
    font-style: normal;
    color: #a3a3a3;
    font-size: 12px;
    line-height: 14px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px 0;
    height: 24px;
    border: 1px solid #a3a3a3;
    margin: 0 -0.5px;

    &:first-child {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
      border-right: none;
    }

    &:last-child {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
      border-left: none;
    }

    &.selected {
      background-color: #7b01b5;
      color: white;
      border-color: #7b01b5;
      z-index: 1;
    }
  }
}

.custom-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-left: 6px;
  border: 1px solid #888;
}
input[type="radio"] {
  display: none;
}
</style>
